import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Operacoes() {
  const { token } = useAuth();
  const [operacoes, setOperacoes] = useState([]);
  const [arquivadas, setArquivadas] = useState([]);
  const [alertas, setAlertas] = useState([]);
  const [criando, setCriando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [arquivando, setArquivando] = useState(null);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [justificativa, setJustificativa] = useState('');
  const [loading, setLoading] = useState(false);
  const [aba, setAba] = useState('ativas');
  const [expandidas, setExpandidas] = useState({});
  const navigate = useNavigate();

  const carregar = async () => {
    const [ops, arq, al] = await Promise.all([
      api.get('/operacoes', token),
      api.get('/operacoes/arquivadas', token).catch(()=>[]),
      api.get('/operacoes/alertas', token).catch(()=>[])
    ]);
    setOperacoes(ops);
    setArquivadas(arq);
    setAlertas(al);
  };

  useEffect(() => { carregar(); }, [token]);

  const criar = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const op = await api.post('/operacoes', { nome, descricao }, token);
      setCriando(false); setNome(''); setDescricao('');
      navigate(`/operacoes/${op.id}`);
    } catch (err) { alert(err.message); }
    finally { setLoading(false); }
  };

  const salvarEdicao = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.patch(`/operacoes/${editando.id}`, { nome, descricao }, token);
      setEditando(null); setNome(''); setDescricao(''); carregar();
    } catch(err) { alert('Erro ao salvar'); }
    finally { setLoading(false); }
  };

  const arquivar = async () => {
    const palavras = justificativa.trim().split(/\s+/).filter(Boolean);
    if (palavras.length < 2) { alert('A justificativa deve ter pelo menos 2 palavras.'); return; }
    try {
      await api.patch(`/operacoes/${arquivando.id}/arquivar`, { justificativa }, token);
      setArquivando(null); setJustificativa(''); carregar();
    } catch(e) { alert('Erro ao arquivar'); }
  };

  const desarquivar = async (op) => {
    try {
      // Limpar justificativa do nome ao reativar
      await api.patch(`/operacoes/${op.id}/reativar`, {}, token);
      carregar();
    } catch(e) { alert('Erro ao desarquivar'); }
  };

  const operacoesAtrasadas = new Set(alertas.map(a => a.operacao_id));
  const alertasPorOp = alertas.reduce((acc, a) => {
    if (!acc[a.operacao_id]) acc[a.operacao_id] = [];
    acc[a.operacao_id].push(a.fase_nome);
    return acc;
  }, {});

  const listaAtual = aba === 'ativas' ? operacoes : arquivadas;

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Minhas Operações</div>
          <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Cada importação tem seu próprio fluxo de 8 fases</div>
        </div>
        <button className="btn-primary" onClick={()=>setCriando(true)}>+ Nova operação</button>
      </div>

      <div style={{display:'flex',gap:8,marginBottom:20}}>
        <button onClick={()=>setAba('ativas')} style={{padding:'7px 18px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,fontWeight:600,background:aba==='ativas'?'#1A2ECC':'#F4F5F9',color:aba==='ativas'?'#fff':'#6B7289'}}>Ativas ({operacoes.length})</button>
        <button onClick={()=>setAba('arquivadas')} style={{padding:'7px 18px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,fontWeight:600,background:aba==='arquivadas'?'#6B7289':'#F4F5F9',color:aba==='arquivadas'?'#fff':'#6B7289'}}>Arquivadas ({arquivadas.length})</button>
      </div>

      {/* Modal Nova/Editar */}
      {(criando || editando) && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100}}>
          <div className="card" style={{width:460,borderRadius:20}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:20}}>{editando?'Editar Operação':'Nova Operação'}</div>
            <form onSubmit={editando?salvarEdicao:criar}>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Nome</label>
                <input className="input-field" placeholder="Ex: Fones Bluetooth — ML" value={nome} onChange={e=>setNome(e.target.value)} required autoFocus />
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Observações (opcional)</label>
                <textarea className="input-field" rows={3} value={descricao} onChange={e=>setDescricao(e.target.value)} style={{resize:'vertical'}} />
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" className="btn-ghost" onClick={()=>{setCriando(false);setEditando(null);setNome('');setDescricao('');}}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={loading}>{loading?'Salvando...':editando?'Salvar →':'Criar →'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Arquivar */}
      {arquivando && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100}}>
          <div className="card" style={{width:460,borderRadius:20}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:8}}>Arquivar Operação</div>
            <div style={{fontSize:13,color:'#6B7289',marginBottom:20}}>"{arquivando.nome}"</div>
            <div style={{marginBottom:20}}>
              <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Justificativa <span style={{color:'#D63B3B'}}>*</span> (mín. 2 palavras)</label>
              <textarea className="input-field" rows={3} placeholder="Ex: Produto inviável após análise..." value={justificativa} onChange={e=>setJustificativa(e.target.value)} style={{resize:'vertical'}} />
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button className="btn-ghost" onClick={()=>{setArquivando(null);setJustificativa('');}}>Cancelar</button>
              <button onClick={arquivar} style={{background:'#D63B3B',color:'#fff',border:'none',borderRadius:8,padding:'10px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Arquivar</button>
            </div>
          </div>
        </div>
      )}

      {listaAtual.length === 0 && (
        <div className="card" style={{textAlign:'center',padding:48}}>
          <div style={{fontSize:32,marginBottom:12}}>{aba==='ativas'?'📦':'🗄️'}</div>
          <div style={{fontSize:16,fontWeight:600,marginBottom:8}}>{aba==='ativas'?'Nenhuma operação ativa':'Nenhuma operação arquivada'}</div>
          {aba==='ativas' && <button className="btn-primary" onClick={()=>setCriando(true)}>Criar primeira operação →</button>}
        </div>
      )}

      {/* 1 por linha */}
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        {listaAtual.map(op => {
          const pct = parseInt(op.pct||0);
          const atrasada = operacoesAtrasadas.has(op.id);
          const fasesAtrasadas = alertasPorOp[op.id] || [];
          const expandida = expandidas[op.id];
          const descLonga = op.descricao && op.descricao.length > 80;

          return (
            <div key={op.id} className="card" style={{
              borderLeft: atrasada?'3px solid #D63B3B':aba==='arquivadas'?'3px solid #9095A8':'3px solid #1A2ECC',
              background: atrasada?'#FFF5F5':'#fff',
              opacity: aba==='arquivadas'?0.85:1,
              cursor: aba==='ativas'?'pointer':'default'
            }}
            onClick={()=>aba==='ativas'&&navigate(`/operacoes/${op.id}`)}>

              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:8,gap:8}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{op.nome}</div>
                </div>
                <div style={{display:'flex',gap:4,flexShrink:0,alignItems:'center'}} onClick={e=>e.stopPropagation()}>
                  {atrasada && <span style={{fontSize:10,fontWeight:700,color:'#D63B3B',background:'#FDEAEA',padding:'2px 6px',borderRadius:4}}>⚠️ {fasesAtrasadas.length}</span>}
                  <span className={`badge ${pct===100?'badge-green':aba==='arquivadas'?'':'badge-blue'}`}>
                    {aba==='arquivadas'?'Arquivada':pct===100?'✓ Concluído':'Em andamento'}
                  </span>
                  {aba==='ativas' && <>
                    <button onClick={()=>{setNome(op.nome);setDescricao(op.descricao||'');setEditando(op);}} style={{background:'#EEF1FF',border:'none',borderRadius:6,padding:'3px 8px',fontSize:10,color:'#1A2ECC',cursor:'pointer'}}>✏️</button>
                    <button onClick={()=>{setArquivando(op);setJustificativa('');}} style={{background:'#F4F5F9',border:'none',borderRadius:6,padding:'3px 8px',fontSize:10,color:'#6B7289',cursor:'pointer'}}>📁</button>
                  </>}
                  {aba==='arquivadas' && (
                    <button onClick={()=>desarquivar(op)} style={{background:'#E6F7F1',border:'none',borderRadius:6,padding:'3px 8px',fontSize:10,color:'#0FA36B',cursor:'pointer',fontWeight:600}}>↩ Reativar</button>
                  )}
                </div>
              </div>

              {op.descricao && (
                <div style={{marginBottom:8}} onClick={e=>e.stopPropagation()}>
                  <div style={{fontSize:11,color:'#6B7289',lineHeight:1.5,display:'-webkit-box',WebkitLineClamp:expandida?'unset':2,WebkitBoxOrient:'vertical',overflow:expandida?'visible':'hidden'}}>{op.descricao}</div>
                  {descLonga && <button onClick={()=>setExpandidas(prev=>({...prev,[op.id]:!prev[op.id]}))} style={{fontSize:10,color:'#1A2ECC',background:'none',border:'none',cursor:'pointer',padding:'2px 0'}}>{expandida?'▲ ver menos':'▼ ver mais'}</button>}
                </div>
              )}

              {atrasada && <div style={{fontSize:10,color:'#D63B3B',marginBottom:6}}>⚠️ {fasesAtrasadas.join(', ')}</div>}

              <div className="progress-bar" style={{marginBottom:6}}>
                <div className="progress-fill" style={{width:pct+'%',background:pct===100?'#0FA36B':atrasada?'#D63B3B':'#1A2ECC'}} />
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:11,color:'#6B7289'}}>
                <span>{op.tarefas_feitas} de {op.total_tarefas} tarefas</span>
                <span style={{fontWeight:600,color:pct===100?'#0FA36B':atrasada?'#D63B3B':'#1A2ECC'}}>{pct}%</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
